import React from "react";
import "../../../../styles/styles.css";
const Banner = () => {
  return (
    <div className="image-header-investor">
      <div className="header-text">
        <div>
          <span>Join a Profitable,</span>
          <span>Fast-</span>
        </div>
        <div className="button-container">
          <span><span>Growing Market</span></span>
          <button className="signup-zowo">Signup with Zowo</button>
        </div>
      </div>
    </div>
  );
};
export default Banner;
